import InputGroup from "@@/core/components/product/shared/InputGroup/InputGroup";
import Discount from "@@/core/components/product/shared/Discount/Discount";
import {BFormInput} from "bootstrap-vue";

export default {
  name: "ProductPricing",
  components: {Discount,InputGroup,BFormInput},
  props: {
    value: Object,
  },
  watch: {
    value(newVal) {
      this.realValue = newVal
    },
    realValue(newVal) {
      this.$emit('input', newVal)
    },
  },
  data() {
    return {
      realValue: this.value,
    }
  },
  computed: {
    canEditVariety() {
      return this.hasPermission('edit_price_variety_product');
    },
  }
}
